declare const $: any;
declare const Mangler: any;

export class Util {

	private static objectMap = new WeakMap();
	private static lastObjectId = 0;

	static scrollIntoView(className) {
		setTimeout(() => {
			$('.' + className).scrollintoview({ duration: 100 });
		}, 0);
	}

	static scrollTo(className, behavior = 'smooth') {
		// Nothing on the page carries the class when the target section did not render - skip quietly.
		const target = $('.' + className)[0];
		if (!target) return;

		target.scrollIntoView({
			behavior,
			block: 'start'
		});
	}

	static objectId(obj) {
		if (this.objectMap.has(obj)) {
			return this.objectMap.get(obj);
		} else {
			const id = ++this.lastObjectId;
			this.objectMap.set(obj, id);
			return id;
		}
	}

	static objectToQueryString(obj) {
		if (!Mangler.isObject(obj)) return '';

		const qs = [];
		Mangler.each(obj, (k, v) => {
			qs.push(k + '=' + encodeURIComponent(v));
		});
		return qs.join('&');
	}

	static spreadsheetColumn(n) {
		if (n < 1) return '';

		let result = '';
		while (n > 0) {
			n -= 1;
			const m = n % 26;
			n = Math.floor(n / 26);
			result = String.fromCharCode(65 + m) + result;
		}
		return result;
	}

	static spreadsheetColumnCoord(col) {
		let result = 0;
		for (let i = 0; i < col.length; i++) {
			const n = col.charCodeAt(i) - 64;
			result = result * 26 + n;
		}
		return result;
	}

	static zeroPad(num, length) {
		const str = String(num);
		const zerosNeeded = Math.max(0, length - str.length);
		return '0'.repeat(zerosNeeded) + str;
	}

	// Blanks the address components on a record (in place) so browsers — Chrome in
	// particular — cannot infer a complete address to offer saving to the user's
	// personal profile when a modal/form closes after a save. autocomplete hints do
	// not suppress that prompt; removing the values from the live inputs does. Call
	// this only after the payload has been captured/cloned, so the save is unaffected.
	// The optional prefix targets grouped fields: '' blanks address_line_1 etc,
	// 'delivery' blanks delivery_address_line_1 etc. Missing fields are left alone.
	static blankAddressFields(record: any, prefix = '') {
		if (!record) return;
		const fields = ['address_line_1', 'address_line_2', 'address_line_3', 'posttown', 'county', 'postcode', 'country'];
		const p = prefix ? prefix + '_' : '';
		fields.forEach(field => {
			const key = p + field;
			if (key in record) record[key] = '';
		});
	}

	static normaliseURL(value): string {
		const url = typeof value === 'string' ? value.trim() : '';
		if (!url) return '';
		return /^[a-z][a-z0-9+.-]*:\/\//i.test(url) ? url : 'https://' + url;
	}

	static isSafeURL(value): boolean {
		return /^https?:\/\//i.test(Util.normaliseURL(value));
	}

	// The host of a web address without "www.", for showing a link short.
	static urlHost(value): string {
		try {
			return new URL(Util.normaliseURL(value)).host.replace(/^www\./i, '');
		} catch (e) {
			return typeof value === 'string' ? value.trim() : '';
		}
	}

	static openURL(value) {
		if (!Util.isSafeURL(value)) return;
		window.open(Util.normaliseURL(value), '_blank', 'noopener');
	}
	static isValidEmail(email: string): boolean {
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email || '').trim());
	}

}
